import { memo, useCallback, useEffect, useRef } from 'react'

import { Badge, Popover } from '@mui/material'
import { NotificationsNoneOutlined } from '@mui/icons-material'

import NotificationsTab from '@tabeeb/modules/notificationsPage/components/NotificationsPage'
import {
  closeNotificationsTab,
  getNotificationsCountRequest,
  openNotificationsTab,
} from '@tabeeb/modules/notificationsPage/actions'
import { getNotificationsCount, getNotificationsTabOpen } from '@tabeeb/modules/notificationsPage/selectors'
import { useDispatch, useSelector } from '@tabeeb/store'
import { IconButton } from '@collaborate-health/uikit'

const Notifications = () => {
  const dispatch = useDispatch()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isOpen = useSelector(getNotificationsTabOpen)

  const notificationsCount = useSelector<number>(getNotificationsCount)

  const handleOpen = useCallback(() => {
    dispatch(openNotificationsTab())
  }, [dispatch])

  const handleClose = useCallback(() => {
    dispatch(closeNotificationsTab())
  }, [dispatch])

  useEffect(() => {
    dispatch(getNotificationsCountRequest())

    return () => {
      dispatch(closeNotificationsTab())
    }
  }, [dispatch])

  return (
    <>
      <IconButton
        ref={buttonRef}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()

          handleOpen()
        }}
      >
        <Badge
          color='accent'
          overlap='rectangular'
          badgeContent={notificationsCount > 0 ? notificationsCount : null}
          max={100}
        >
          <NotificationsNoneOutlined />
        </Badge>
      </IconButton>
      <Popover
        open={isOpen}
        anchorEl={buttonRef.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={handleClose}
        PaperProps={{ sx: { height: 566, width: 685 } }}
      >
        <NotificationsTab />
      </Popover>
    </>
  )
}

export default memo(Notifications)

